import { useParams } from 'react-router-dom';

import { useCoachActivities } from '@/data/coachActivity';
import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';
import { COACH_ACTIVITY_TENANT_STATUS } from '@/app/coachActivityTenant/enums';

import { currencyFormat } from '@/helpers/stringHelpers';
import ApproveDialog from '@/app/coachActivityTenant/ApproveDialog';

const Tab = () => {
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);

  const coachActivity = coachActivities.data.find(
    (activity) => activity.id === params.coachActivityId
  );

  const getBadgeVariant = (status) => {
    switch (status) {
      case COACH_ACTIVITY_TENANT_STATUS.PENDING:
        return 'outline';
      case COACH_ACTIVITY_TENANT_STATUS.APPROVED:
        return 'secondary';
      case COACH_ACTIVITY_TENANT_STATUS.REJECTED:
        return 'destructive';
      default:
        return 'default';
    }
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <h2 className="text-xl font-bold">{coachActivity.activity.title}</h2>
        {coachActivity.coachActivityTenants?.[0] && (
          <Badge
            variant={getBadgeVariant(
              coachActivity.coachActivityTenants?.[0].status
            )}
          >
            {coachActivity.coachActivityTenants?.[0].status}
          </Badge>
        )}
      </div>
      <h3 className="font-bold">Rate</h3>
      <div className="flex flex-col gap-2 mb-6">
        <span>{currencyFormat(coachActivity.hourlyRate)}</span>
      </div>
      <h3 className="font-bold mb-2">Styles</h3>
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="experience-style"
            disabled
            checked={coachActivity.isExperienceStyle}
          />
          <label
            htmlFor="experience-style"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Experience / Adventure
          </label>
        </div>
      </div>
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="fundamentals-style"
            disabled
            checked={coachActivity.isFundamentalsStyle}
          />
          <label
            htmlFor="fundamentals-style"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Fundamentals / Skills
          </label>
        </div>
      </div>
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="freestyle"
            disabled
            checked={coachActivity.isFreeStyle}
          />
          <label
            htmlFor="freestyle"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Freestyle / High Performance
          </label>
        </div>
      </div>
      <h3 className="font-bold">Locations</h3>
      <div>List Coach Activity Locations Here </div>
      {/* // TODO ADD LIST OF COACH ACTIVITY LOCATIONS FOR THIS COACH */}
      {coachActivity.coachActivityTenants?.[0].status ===
        COACH_ACTIVITY_TENANT_STATUS.PENDING && (
        <div className="flex justify-end">
          <ApproveDialog />
        </div>
      )}
    </div>
  );
};

export default Tab;
